module.exports = __webpack_public_path__ + "static/media/0013.5bb90b9f.png";